import { BirdviewSection } from '../../DashboardBirdview.constants'
import {
  BIRDVIEW_KPIS_MOCK,
  BIRDVIEW_REQUEST_CHARTS_MOCK,
} from '../../DashboardBirdview.mock'

import {
  toBirdviewKpis,
  toBirdviewRequestsCharts,
} from './useBirdviewAnalyticsLoaders.utils'

export function useBirdviewAnalyticsLoaders() {
  // TODO KPIs and request charts run on the fixture until `/insights` ships.
  async function getKpis({ preset }) {
    return toBirdviewKpis(BIRDVIEW_KPIS_MOCK[preset])
  }

  async function getRequestsCharts() {
    return toBirdviewRequestsCharts(BIRDVIEW_REQUEST_CHARTS_MOCK)
  }

  return {
    getters: {
      [BirdviewSection.ChartRequests]: getRequestsCharts,
      [BirdviewSection.Kpis]: getKpis,
    },
  }
}
